import React from "react"

export const Header = () => {
    return (
        <div className="watchoDownloadHeader">
            <div className="watchoDownloadLogo">
                <img src="../images/WatchoDownloadLP/logo.png" />
            </div>
        </div>
    )
}
